/**************Nutrient Calculator****************************************/
//  function printTable() {
//   // alert("printable");
//   window.print();
//    event.preventDefault();
//  }




const navidiumProductId = 9031684751618; // Replace with your product ID

async function checkCart() {
  const response = await fetch('/cart.js');
  const cart = await response.json();
  const hasOnlyNavidium =
    cart.items.length === 1 && cart.items[0].product_id === navidiumProductId;

  if (hasOnlyNavidium) {
    await fetch(`/cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: 1, quantity: 0 }),
    });
    alert('Please add another product to purchase Navidium Protection.');
    location.reload();
  }
}

document.addEventListener('DOMContentLoaded', checkCart);



window.addEventListener('pageshow', function(event) {
    // Check if the user is navigating back to the specific page URL
    if (window.location.href === "https://humboldtssecretsupplies.com/pages/starter-kit-try-before-you-buy?_ab=0&_fd=0&_sc=1") {
        // If the page is loaded from cache (back button is pressed)
        if (event.persisted) {
            // Reload the page if it's being loaded from the cache
            window.location.reload();
        }
    }

});
$(document).ready(function() {
    // When a span with class 'popup-trigger' is clicked
    $("body").on("click",".popup-trigger" , function(e) {
      e.preventDefault();
        // Get the snippet ID from the data attribute
        var snippetId = $(this).data("snippet");
        // Get the content of the selected snippet
        var snippetContent = $("#" + snippetId).html();
        // Insert the snippet content into the popup
        $("#popup-text").html(snippetContent);

        // Show the popup
        $("#popup-modal").fadeIn();
    });

    // Close the popup when the close button is clicked
     $("body").on("click","#popup-modal .close-popup", function(e) {
       e.preventDefault();
        $("#popup-modal").fadeOut();
    });

    // Close the popup if the user clicks outside the modal
    $(window).on("click", function(event) {
        if ($(event.target).is("#popup-modal")) {
            $("#popup-modal").fadeOut();
        }
    });
});
function getQueryParam(name,link) {
  const urlParams = new URLSearchParams(new URL(link).search);
    return urlParams.get(name);
}
 var handleRebuyUpsell = 0;
 document.addEventListener('rebuy:cart.ready', (event) => { 
  console.log('rebuy:cart.change event', event.detail); 
 // var handleRebuyUpsell = setInterval(upsellRebuyJTPL,500);
   // setTimeout(function(){
   //   upsellRebuyJTPL();
   // },500);
   cartMagicJTPL(event);
});

var x=0;
function upsellRebuyJTPL(){
    var isTreeTrunk = 0;
    var isSweetSticky = 0;
    var total_price = 0;
    var label_text = '';
     if($("#rebuy-widget-180943 .rebuy-widget-content .rebuy-product-block").length > 0){
      $("#rebuy-widget-180943 .rebuy-widget-content .rebuy-product-block").each(function() {       
        if($(this).find(".rebuy-select").length > 0){
          var variant = $(this).find(".rebuy-select").val();         
        }else{
          var getlink = $(this).find(".rebuy-product-image").attr("href"); 
          var variant = getQueryParam('variant',"https://humboldtssecretsupplies.com"+getlink);  
        }
        
        if($(this).hasClass("sweet-sticky-sample")){
          isSweetSticky++;
           $(this).find(".rebuy-product-title .sub-title-jtpl").remove();
          $(this).find(".rebuy-product-title").append("<small class='sub-title-jtpl' style='display:block;'>Sweet & Sticky is a source of carbohydrates, energy and microbe food that can be used on all indoor or outdoor plants and is effective in all mediums.</small>")
        } else if($(this).hasClass("tree-trunk-sample")){
          isTreeTrunk++;
           $(this).find(".rebuy-product-title .sub-title-jtpl").remove();
          $(this).find(".rebuy-product-title").append("<small class='sub-title-jtpl' style='display:block;'>Tree Trunk is a potassium silicate based product which helps your plants natural ability to strengthen its cell walls.</small>")
        }
        
        var money = $(this).find(".rebuy-money span:eq(1)").text();
        // console.log(money);
         money = money.replace("$","");
       // console.log(money);
         total_price = parseFloat(total_price) + parseFloat(money);
        // console.log(total_price);
       $(this).find(".rebuy-button-container").html(`<a data-variant="${variant}" href="https://humboldtssecretsupplies.com/cart/add?items[][id]=${variant}&items[][quantity]=1&&items[][selling_plan]=3039199490&return_to=/checkout" class="try-on-button-jtpl btn product-form__cart-submit">
      TRY BEFORE YOU BUY </a>`);
      });

   if(isTreeTrunk > 0 && isSweetSticky > 0){
     var heading = 'Add a Quart of Sweet & Sticky and Tree Trunk <br>for $0 now as well.';
     var Button ="YES, I'LL TRY OUT SWEET & STICKY AND TREE TRUNK ALSO";
     var label_text = "<span style='color:red'><sup>*</sup></span>YOU WILL SEE A PREAUTHORIZATION HOLD FOR THE FULL AMOUNT ON YOUR CARD IMMEDIATELY. We provide our premium full-size products delivered directly to your door, simply pay $5.95 for shipping. You have 30 days to try them out.  If kept after 30 days, you will be charged $98.99 (plus tax).If you click “"+Button+"” below you will be charged an additional <TOTALAMOUNT> (plus tax) if kept after 30 days. Easily cancel by emailing us at <a href='mailto:support@humboldtssecret.com'>support@humboldtssecret.com</a>. Purchases under 'Try Before You Buy' are subject to our <button class='terms-service-jtpl custom-popup-open' data-snippet='terms_of_service'>Terms of Service</button>.";
     var Button2 ="No Thanks, I will just take the Starter Kit";
   }else if(isTreeTrunk > 0 && isSweetSticky == 0){
     var heading = '"Add a Quart of Tree Trunk" <br>for $0 now as well.';
     var Button ="YES, I'LL TRY OUT TREE TRUNK ALSO";
         var label_text = "<span style='color:red'><sup>*</sup></span>YOU WILL SEE A PREAUTHORIZATION HOLD FOR THE FULL AMOUNT ON YOUR CARD IMMEDIATELY. We provide our premium full-size products delivered directly to your door, simply pay $5.95 for shipping. You have 30 days to try them out.  If kept after 30 days, you will be charged $125.96 (plus tax).If you click “"+Button+"” below you will be charged an additional <TOTALAMOUNT> (plus tax) if kept after 30 days. Easily cancel by emailing us at <a href='mailto:support@humboldtssecret.com'>support@humboldtssecret.com</a>. Purchases under 'Try Before You Buy' are subject to our <button class='terms-service-jtpl custom-popup-open' data-snippet='terms_of_service'>Terms of Service</button>.";
 var Button2 ="No Thanks, I will just take the Starter Kit and SWEET & STICKY";
   }else if(isTreeTrunk == 0 && isSweetSticky > 0){
     var heading = '"Add a Quart of Sweet & Sticky" <br>for $0 now as well.';
     var Button ="YES, I'LL TRY OUT SWEET & STICKY ALSO";
     var label_text = "<span style='color:red'><sup>*</sup></span>YOU WILL SEE A PREAUTHORIZATION HOLD FOR THE FULL AMOUNT ON YOUR CARD IMMEDIATELY. We provide our premium full-size products delivered directly to your door, simply pay $5.95 for shipping. You have 30 days to try them out.  If kept after 30 days, you will be charged $123.97 (plus tax).If you click “"+Button+"” below you will be charged an additional <TOTALAMOUNT> (plus tax) if kept after 30 days. Easily cancel by emailing us at <a href='mailto:support@humboldtssecret.com'>support@humboldtssecret.com</a>. Purchases under 'Try Before You Buy' are subject to our <button class='terms-service-jtpl custom-popup-open' data-snippet='terms_of_service'>Terms of Service</button>.";
var Button2 ="No Thanks, I will just take the Starter Kit and Tree Trunk"; 
   }
   $(".rebuy-widget-content .super-title").html(heading);
  if(x==0 || x==1){  
    $("button.rebuy-button.rebuy-button--mlr-10.decline").text(Button2);
  //update Continue to Checkout button in rebuy
     $(".rebuy-button-actions.rebuy-pre-purchase-actions").find(".rebuy-button.outline").addClass("add-both-try-products-jtpl").attr("type","button");
      $(".rebuy-button-actions.rebuy-pre-purchase-actions").find(".rebuy-button.outline").text(Button).hide();
       $(".rebuy-widget-container .bottom-container .rebuy-button-actions").find(".decline-both-jtpl").remove();
         $(".rebuy-widget-container .bottom-container .rebuy-button-actions").find(".add-both-try-products-jtpl").remove();
  $(".rebuy-widget-container .bottom-container .rebuy-button-actions").append("<button type='button' class='btn-outline decline-both-jtpl'>"+Button2+"</button>")
      $(".rebuy-widget-container .bottom-container .rebuy-button-actions").append("<button type='button' class='btn add-both-try-products-jtpl'>"+Button+"</button>")
   //total_price = total_price + 98.99;
   if(label_text.indexOf("<TOTALAMOUNT>")>-1){
           label_text = label_text.replace("<TOTALAMOUNT>","$"+total_price.toFixed(2));

   }
   $(".rebuy-widget-container .bottom-container").find(".term-label-jtpl").remove();
  $(".rebuy-widget-container .bottom-container").prepend("<label class='term-label-jtpl'><input type='checkbox' name='terms_jtpl' id='terms_jtpl'>&nbsp;"+label_text+"</label>")
/**terms & condition popup click ***/
    $("body").on("click",".custom-popup-open",function(e){
     e.preventDefault();
       $(".popup-trigger").eq(3).trigger("click");
   });
    
  $("body").on("change",".rebuy-widget-content .rebuy-product-block .rebuy-select",function(e){
        e.preventDefault();
        var variant = $(this).val();
         $(this).parents(".rebuy-product-block").find(".rebuy-button-container").html(`<a data-variant="${variant}" href="https://humboldtssecretsupplies.com/cart/add?items[][id]=${variant}&items[][quantity]=1&&items[][selling_plan]=3039199490&return_to=/checkout" class="try-on-button-jtpl btn product-form__cart-submit">
      TRY BEFORE YOU BUY </a>`);
      });
 
   document.querySelectorAll('.rebuy-pre-purchase-actions button.decline-both-jtpl').forEach(element => {
  element.addEventListener('click', function(event) {
     event.preventDefault();
    // Your code here
    const checkbox = document.getElementById('terms_jtpl');

if (checkbox.checked) {
  window.location.href ="/checkout";
  //console.log("Checkbox is checked.");
} else {
  alert("Please accept terms & conditions!")
  return false;
}
    
     });
 });
   
document.querySelectorAll('.add-both-try-products-jtpl').forEach(element => {
  element.addEventListener('click', function(event) {
     event.preventDefault();
    // Your code here
    const checkbox = document.getElementById('terms_jtpl');

if (checkbox.checked) {
  //console.log("Checkbox is checked.");
} else {
  alert("Please accept terms & conditions!")
  return false;
}
      if(isTreeTrunk > 0 && isSweetSticky > 0){
        var items = [{
                    id: 45634058977538, //sweetsticky
                    quantity: 1,
                    selling_plan: 3039199490,
                  properties: {
                    Terms: "accepts"
                    }  
                },
              {
                    id: 45622840230146, //teatrunk
                    quantity: 1,
                    selling_plan: 3039199490,
                properties: {
                    Terms: "accepts"
                    }  
                }];
   }else if(isTreeTrunk > 0 && isSweetSticky == 0){
        var items = [
              {
                    id: 45622840230146, //teatrunk
                    quantity: 1,
                    selling_plan: 3039199490,
                properties: {
                    Terms: "accepts"
                    }  
                }];
     }else if(isTreeTrunk == 0 && isSweetSticky > 0){
        var items = [{
                    id: 45634058977538, //sweetsticky
                    quantity: 1,
                    selling_plan: 3039199490,
                  properties: {
                    Terms: "accepts"
                    }  
                }];
    }
    
    // console.log("Button clicked!by code");
   $(".rebuy-modal-close").trigger("click");
   // alert("heree--");
             $.ajax({
        type: "POST",
        url: "/cart/add.js",
         async:false,
        data: {
            items: items
        },
        dataType: "json",
        success: function (data) {
           Rebuy.SmartCart.show(); 
            // Redirect to the checkout page or display a success message
            window.location.href = "/checkout";
        },
        error: function (xhr, status, error) {
            // Handle any errors that occur during the AJAX request
            console.log("Error adding item to cart:", error);
        }
    });

  });
});

    document.querySelectorAll('.rebuy-widget-container').forEach(element => {
element.addEventListener('click', function(event) {
     if ($(event.target).closest('.rebuy-widget-content').length == 0) {
        // Prevent the default action and stop further propagation
        event.stopPropagation();
        event.preventDefault();
      return false;
    }
});
});  

      // When a span with class 'popup-trigger' is clicked
    $("body").on("click",".popup-trigger" , function(e) {
      e.preventDefault();
        // Get the snippet ID from the data attribute
        var snippetId = $(this).data("snippet");
        // Get the content of the selected snippet
        var snippetContent = $("#" + snippetId).html();
        // Insert the snippet content into the popup
        $("#popup-text").html(snippetContent);

        // Show the popup
        $("#popup-modal").fadeIn();
    });

    // Close the popup when the close button is clicked
     $("body").on("click","#popup-modal .close-popup", function(e) {
       e.preventDefault();
        $("#popup-modal").fadeOut();
    });
    
      console.log("hereee--"+x+"---"+$(".rebuy-widget-content .rebuy-product-block").length);
 
}
 x++;      
    clearInterval(handleRebuyUpsell);
      handleRebuyUpsell=0;
    }
   
}

    


 $("body").on("change",".product-form .custom_product_select",function(e){
   
    if($("body").hasClass("temp-sweet-sticky-sample") == true){
      var $this = $(this);
      var option = $.trim($(this).val());
       var variant = 0;
      $(".product-form__variants option").each(function(){
        //alert($.trim($(this).text())+"==="+option);
        if($.trim($(this).text()) == option){
          var variant = $(this).attr("value");
            $this.parents(".product-form").find(".product-form__item.product-form__item--submit").html(`<a data-variant="${variant}" href="https://humboldtssecretsupplies.com/cart/add?items[][id]=${variant}&items[][quantity]=1&&items[][selling_plan]=3039199490&return_to=/checkout" class="try-on-button-jtpl btn product-form__cart-submit">
      TRY BEFORE YOU BUY </a>`);
          return false;
        }
           
      });
      
    }

 });
function updateCartQuantity(variantId, newQuantity) {
    $.ajax({
        type: "POST",
        url: "/cart/change.js",
      async:false,
        data: {
            id: variantId, // The variant ID of the item to change
            quantity: newQuantity // The new quantity you want to set
        },
        dataType: "json",
        success: function(cart) {
             Rebuy.SmartCart.show(); 
          return false;
        },
        error: function(xhr, status, error) {
            console.log("Error updating quantity:", error);
        }
    });
}

function cartMagicJTPL(event){
  var items = event.detail.cart.cart.items;
    var cart_price_rebuy=event.detail.cart.cart.original_total_price;
   var original_price=event.detail.cart.cart.total_price;
  var items_subtotal_price=event.detail.cart.cart.original_total_price;
  
var disocunted_price=items_subtotal_price - event.detail.cart.cart.total_discount;
var cut_price=items_subtotal_price;
    var price = 0;
    var check='false';
  for(var x= 0; x<items.length ;x++){
    var title = items[x].product_title;
   var handle = items[x].handle;
    if(handle.indexOf("-sample")>-1){
      check = 'true'; 
      var final_price = items[x].final_line_price;
      price= parseFloat(price) + parseFloat(final_price);
       $("li.product-"+handle+" .rebuy-cart__flyout-item-price").html("$0");
      var id = items[x].id;
     var qty = items[x].quantity;
      console.log(id);
      if(qty>1){
        if(id == "45579338776834" || id == "45634058977538" || id == "45622840230146"){
          updateCartQuantity(id,"1");
        }
      }
        
    }//sample condition
  }//for loop
  console.log(check);
    if(check == 'true'){
      var newMessage = 'Simply pay $5.95 for shipping.<small style="display:block;">*only for purchases under "Try Before You Buy" products. </small>';
    $('div[data-rebuy-component="announcement-bar"] .message').each(function(index) {
        $(this).html(newMessage);
    });
  }else{
       var newMessage1 = 'Buy 3 Save 15% | Buy 6 Save 20%';
        var newMessage2 = 'Free Shipping On US Domestic Orders $75+';
  
    $('div[data-rebuy-component="announcement-bar"] .message').each(function(index) {
      console.log(index);
      if(index=='0'){
        $(this).html(newMessage1);
      }else if(index=='1'){
        $(this).html(newMessage2);
      }else{
         $(this).html(newMessage1);
      }
        
    }); 
  }

    if($(".rebuy-cart__flyout-subtotal-compare-amount").length > 0 && $(".rebuy-cart__flyout-subtotal-final-amount").length > 0){
      var cut_price_new = cut_price - price;
      cut_price_new = cut_price_new/100;
      var original_price_new = original_price - price;
      original_price_new = original_price_new/100;
      $(".rebuy-cart__flyout-subtotal-final-amount").text("$"+original_price_new.toFixed(2));
      $(".rebuy-cart__flyout-subtotal-compare-amount").text("$"+cut_price_new.toFixed(2));
    }else{
        var original_price_new = original_price - price;
      original_price_new = original_price_new/100;
      $(".rebuy-cart__flyout-subtotal-amount").text("$"+original_price_new.toFixed(2));
    }
}

document.addEventListener('rebuy:cart.change', (event) => { 
    const navidiumProductId = 9031684751618; // replace with your Navidium product ID
    // Disable the button
$("#nvd-with-checkout-btn").addClass("nvd-disabled");

  const validateCart = (cart) => {
    const hasOnlyNavidium =
      cart.items.length === 1 &&
      cart.items[0].product_id === navidiumProductId;

    if (hasOnlyNavidium) {
      alert('Please add another product to purchase Navidium Protection.');
       const itemId = cart.items[0].id;
        if (window.Rebuy && Rebuy.SmartCart) {
          Rebuy.SmartCart.removeItem(itemId);
        }
    }
  };

  // Check on initial load
  validateCart(event.detail.cart);
// Re-enable after 1 second
setTimeout(function() {
    $("#nvd-with-checkout-btn").removeClass("nvd-disabled");
}, 1800);
var cart_bubble = event.detail.cart.cart.item_count;
  $(".header-cart-count").text(cart_bubble);
  console.log(event);
  setTimeout(function(){
    upsellRebuyJTPL();
    cartMagicJTPL(event);
  },200);
      var item = event.detail.item;
  console.log(item);
});


document.addEventListener("rebuy:smartcart.line-item-increase", (event) => {
  const smartcart = event.detail.smartcart;
  const item = event.detail.item;
  console.log(item.id);
    if(item.id == "45579338776834" || item.id == "45634058977538" || item.id == "45622840230146"){
      updateCartQuantity(item.id,"1");
    }
  console.log("rebuy:smartcart.line-item-increase: smartcart", smartcart, item);
});

$(document).ready(function() {
 //var handleRebuyUpsell = setInterval(upsellRebuyJTPL,500);
 $("body").on("click", ".try-on-button-jtpl", function (e) {
    e.preventDefault();

    // Get the variant ID from the data attribute
    var variant = $(this).data("variant");

    // Set up the AJAX request
    $.ajax({
        type: "POST",
        url: "/cart/add.js",
       async:false,
        data: {
            items: [
                {
                    id: variant,
                    quantity: 1,
                    selling_plan: 3039199490,
                  properties: {
                    Terms: "accepts"
                    }                  
                }
            ]
        },
        dataType: "json",
        success: function (data) {
  
        
           Rebuy.SmartCart.show(); return false;
            // Redirect to the checkout page or display a success message
           // window.location.href = "/checkout";
        },
        error: function (xhr, status, error) {
            // Handle any errors that occur during the AJAX request
            console.log("Error adding item to cart:", error);
        }
    });
});

$('.product-form button').on('click', function(event) {
    event.preventDefault(); // Prevent the default form submission
 var $this = $(this).parents(".product-form"); 
  console.log( $this.serialize());
  
    $.ajax({
        type: 'POST',
        url: $this.attr('action') + '.js', // Convert action to AJAX-compatible URL
        data: $this.serialize(), // Serialize form data
        async:false,
        dataType: 'json',
        success: function(response) {
            console.log('Item added to cart:', response);
            // Optionally redirect or show a message
           Rebuy.SmartCart.show(); return false;
        },
        error: function(error) {
            console.error('Error adding item to cart:', error);
            // Optionally display an error message
            alert('Failed to add item to cart. Please try again.');
        }
    });
});
  
    // Select all the dropdowns for product options
    $('.custom_collection_variant').on('change', function() {
        const selectedValue = $(this).val(); // Get the selected value
  // Get the currently selected option element
        const selectedOption = $(this).find('option:selected');
 // Get the variant_price attribute from the selected option
        const price = selectedOption.attr('variant_price');
   // alert(`You selected: ${selectedValue}\nPrice: ${price}\nClass: ${price }`);
 $(this).closest('.product-form').siblings('.price_variation').text("From "+price);
        
    });
  
});


$( ".product_sticky_cart .single-option-selector-product-hero" ).on( "change", function() {
   var $option = $(this).find('option:selected').text();
  console.log($option);
  $("#ProductSelect-product-hero").find("option").removeAttr("selected")
  $("#ProductSelect-product-hero").find("[var_title='"+$option+"']").attr("selected","selected")
  setTimeout(function() {
    var selected_price = $('#ProductSelect-product-hero').find(":selected").attr("data-price");
  var price = $('.rc_widget__price--onetime').html();
    $('.product_sticky_cart').find('.custom_main-price').text(selected_price);
    $('.product__price').find('.custom_main-price').text(selected_price);
    
     }, 100);
});

var timerCook = getCookie('timer');
  if (!timerCook) {
      setCookie('timer', Date.now());
  } else if ((-1 * (getCookie('timer') - Date.now()) / 3600 / 24) >= (60 * 24)) {
      setCookie('timer', Date.now());
  }

  window.cookieStore ||= {};
  function getCookie(name) {
      try {
          var match = document.cookie.match(RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
          return match ? match[1] : null;
      } catch (err) {
          return window.cookieStore[name];
      }
  }

  function setCookie(name, value) {
      try {
          document.cookie = name + "=" + value + "; max-age=" + 24 * 60 * 60;
      } catch (err) {
          window.cookieStore[name] = value;
          return;
      }
  }

/**** condition for faq if not any question in faq  on product page ***/
$(document).ready(function() {
   function toggleMobileInfo() {
        if ($(window).width() < 768) {
            $('.mobile_info_block').show();
          $('.footer_logo').hide();
        } else {
            $('.mobile_info_block').hide();
          $('.footer_logo').show();
        }
    }
   // Run on page load
    toggleMobileInfo();

    // Run on resize
    $(window).resize(function() {
        toggleMobileInfo();
    });

   
  
$(".commercial_btn_jtpl a").click(function (e){
e.preventDefault();
 if ($("body").hasClass("Widget_new-wholesale-page")) {
var scroll_to_a = $('.form-vertical iframe').offset().top - 250;
 }
  if ($("body").hasClass("Widget_Commercial-form")) {
var scroll_to_a = $('#commercialform').offset().top - 250;
 }
    if ($("body").hasClass("Widget_new-manufcturing-product")) {
var scroll_to_a = $('#MainContent iframe').offset().top - 250;
 }
 $('html, body').animate({
      scrollTop: scroll_to_a
  }, 1000);
});
  
// $('a .loox-rating').on('click',function(e){
//   e.preventDefault();
//   var scroll_toa = $('.loox-reviews-default').offset().top - 250;
//    $('html, body').animate({
//         scrollTop: scroll_toa
//     }, 1000);
// });

  var count_elements = $('.product-faq-tab-sec').length;
  if(count_elements > 0){
    $(".product-custom-faq-section").css("display","block");	
  }else{
    $(".product-custom-faq-section").css("display","none");
  }


  var findFlexSlider = setInterval(function(){  
    var count_elem = $('.reviews-carousel .slick-list .slick-track .slick-slide').length;
    if(count_elem > 0){
      $(".product-custom-review-sec").css("display","block");	
    }else{
      $(".product-custom-review-sec").css("display","none");
    }
    clearInterval(findFlexSlider);
  }, 100);

});

// OPTION VALUES ( SAVED MONEY )
function ssmoney()
{
  if($('body').hasClass('Widget_Timelapse')){
    var regularPrice=$('option:selected', '#ProductSelect-Landing-product-hero').attr('data-saved-amount');
  }
  else{
    var regularPrice=$('option:selected', '#ProductSelect-product-hero').attr('data-saved-amount');
  }
  var saved_price= "Save"+" "+regularPrice;
  console.log(saved_price);
  if(regularPrice != undefined )
  {
    $('span.custom-price span').text(saved_price);
    //   $('.rc_widget__option--subsave').css('display','none');
  }

  else{
    //$('.rc_widget__option--subsave').css('display','block');
  }
}
$(document).ready(function(){
  ssmoney();
  
  $('.single-option-selector').change(function(){
    ssmoney();
    var Selected_option_text=$.trim($('.product-form__variants option:selected').text().toLowerCase());
    var Selected_option_textFound = Selected_option_text.includes('buy 1');
    if(Selected_option_textFound)
    {
      $('.rc_widget__option--subsave').removeClass('For_Hidden');
      $('.rc_widget__option__input--subsave').trigger('click');

    }
    else{
      $('.rc_widget__option--subsave').addClass('For_Hidden');
      $('.rc_widget__option__input--onetime').trigger('click');
    }
  });
});



function ssmoney()
{
  if($('body').hasClass('Widget_Timelapse')){
    var regularPrice=$('option:selected', '#ProductSelect-Landing-product-hero').attr('data-saved-amount');
  }
  else{
    var regularPrice=$('option:selected', '#ProductSelect-product-hero').attr('data-saved-amount');
  }
  console.log(regularPrice);
  var saved_price= "Save"+" "+regularPrice;
  console.log(saved_price);
  if(regularPrice != undefined )
  {
    $('span.custom-price span').text(saved_price);
    //  $('.rc_widget__option--subsave').css('display','none');
    $(this).removeClass('.recharge-inner-most-price');
  }
  else{
    //$('.rc_widget__option--subsave').css('display','block');
  }
}
// window.onscroll = function() {scrollFunction()};

// function scrollFunction() {
//   if($(window).width() <=767){
//     var header=$('.main-header').outerHeight();
//     if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
//       $('.main-header').addClass('header-scrolled');
//       $('div#shopify-section-notification-bar').css('margin-top',header);
//     } else {
//       $('.main-header').removeClass('header-scrolled');
//       $('div#shopify-section-notification-bar').css('margin-top',header);

//     }
//   }
// }
// $(document).ready(function(){
//   function headersticky(){
//     if($(window).width() <=767){

//       var header=$('.main-header').outerHeight();
//       $('div#shopify-section-notification-bar').css('margin-top',header);
//     }
//     else{
//       $('div#shopify-section-notification-bar').css('margin-top',0);}
//   }
//   headersticky();
//   $(window).resize(function(){
//     headersticky();
//   });
// });


// function Banner_height(){
//  /* banner height */
//   var header_height= $('.main-header').outerHeight();
//   var header_heightN= $('#shopify-section-notification-bar').outerHeight();
//   var T=header_height +header_heightN;

//    var partner_logo_height = $('.partner-logo').outerHeight();
// 	var bottom_box= $('#bottom-box .action').outerHeight();
//    var T2= partner_logo_height + T + bottom_box;
//      let vh = window.innerHeight * 0.01;
//       document.documentElement.style.setProperty('--vh', `${vh}px`);
//     var newHeight= "calc(var(--vh, 1vh) * 100 - "+T2+"px)";
//      $('.main_banner').css("height",newHeight);
 
//    /* banner height end here */ 
// }




// SHOW WIDGET ON TIMELAPSE PAGE
jQuery(document).ready(function($) {
  
  if($('body').hasClass('Widget_Timelapse')){
    var interval = null;
    interval = setInterval(rc_container_wrapper,5000);
    function rc_container_wrapper(){
      if ($(".rc_container_wrapper").length > 1){
        clearInterval(interval);
      }
      else{
        if ($(".rc_container_wrapper").length == 0 ){
          if ($(".Vault").length > 0) {
             var widget = ReChargeWidget.createWidget({
            productId:  1829788352578
          });
          }else{
            var widget = ReChargeWidget.createWidget({
            productId: 8831721013506
          })
          }
         
        }
      }
    }
  }
 
//    $('body').on('click', '#Barsicon', function(e) { 
//     e.preventDefault();
//     $(this).attr("style","display:block !important;");
//     if($(this).find("em").hasClass('fa-close')){      //cross
      
//         $(this).find("em").removeClass("fa-close").addClass("fa-bars");
     
//     }else{
//          $(this).find("em").removeClass("fa-bars").addClass("fa-close");
   
     
//     }
//   });
});
// $(window).on('resize load scroll',function(){
//     var inview = $(".main_banner").inView();
//     //alert(T +'=='+ offset);
//     if(inview == true){
//       if($(window).width() < 1025){
//         Banner_height();
//       }
//     }

//   });

  $(window).on('resize load',function(){
     var maxHeight = 0;

    $("ul.grid.grid--blog li  h3").each(function(){
      if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
    });
    $("ul.grid.grid--blog li  h3").height(maxHeight);
  });


$(".action").click(function(){
$(".mobile").addClass('popup-activated');
});

$('.action').on('swipeup',function(){
  $(".mobile").addClass('popup-activated');
});
// $(".steps.swipe_up_popup").swipedown(function(e, touch) { 
// $(".mobile").removeClass('popup-activated');
// });


$(".close_popup").click(function(){
$(".mobile").removeClass('popup-activated');


});

$(".close_bottom").click(function(){
$(".mobile").addClass('popup-display-none');


});

$(".calendify_button").click(function(){
$(".calendify_wrapper").removeClass('hide');
});
/**************Nutrient Calculator****************************************/
function printTable() {
    // alert("table print");
  window.print();
  event.preventDefault();
}



/**************Nutrient Calculator*******************************************/
 
//    $(document).on('click','.slick-next',function(){

//             if($('.product__slide').hasClass('slick-active')){
//               //console.log('clicked');
//             var size = $(this).parents('.product__main-photos-wrapper').find('.slick-active').find('.photoslide_image').attr('data-size');
          
//             if($('.size_'+size).length > 0 ){
          
//               $('.product__price').show();
//               $('.all_price_show').hide();
           
//               $('.size_'+size).find('label').trigger('click');              
//             }else{
//               $('.product__price').hide();
//               $('.all_price_show').show();
           
          
//             }
          
                      
//             }
         

//             });
            
//               $(document).on('click','.slick-prev',function(){

//                 var data_slick_index = $('.product__slide.starting-slide.slick-slide.slick-current.slick-active').attr('data-slick-index');
                
//                 if(data_slick_index == 0){
                
//                   $('.variant-input label').addClass('remove_select');
                  
//                   $(".product__price").hide();
//                   $(".all_price_show").show();
                
                  
//                 }
             
//               if($('.product__slide').hasClass('slick-active')){
//                 //console.log('clicked');
//               var size = $(this).parents('.product__main-photos-wrapper').find('.slick-active').find('.photoslide_image').attr('data-size');
//                if($('.size_'+size).length > 0 ){
//                 $('.product__price').show();
//                 $('.all_price_show').hide();
             
             
//                 $('.size_'+size).find('label').trigger('click');
//               }else{
//                 $('.product__price').hide();
//                 $('.all_price_show').show();
             
            
//               }
//               }

 
//               });
           
              
//               $(document).on('change','.variant-input input[type=radio]',function(){
//                 var value = $(this).parents(".variant-input").attr("data-size");
//                 var id = $(".product__main-photos-wrapper").find(".slick-slider").attr("id");
//                 var size = $('.product__main-photos-wrapper').find('.photoslide_image[data-size='+value+']').parents(".product__slide").attr('data-slick-index');
//                 $('#'+id).slick('slickGoTo', size);
           
    
//                 $('.product__price').show();
//                 $('.all_price_show').hide();
             
//                 });


// 11/1/2023 Start


// $(document).ready(function(){
//     $(window).scroll(function(){
//         if ($('.menufactring-video-tag').isOnScreen()) {
//             $('.menufactring-video-tag').trigger('play');
//             console.log('play');
//         } else {
//             $('.menufactring-video-tag').trigger('pause');
//             console.log('pause');
//         }
//     });
// });
// 11/1/2023 End

// $('.custom_announcement_slideshow').slick({
//   dots: false,
//   autoplay:true,
//   speed:7000,
//   prevArrow: '<i class="icon icon-chevron-left" ><svg aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 7 11"><path d="M5.5.037a1.5 1.5 0 0 1 1.06 2.56l-2.94 2.94 2.94 2.94a1.5 1.5 0 0 1-2.12 2.12l-4-4a1.5 1.5 0 0 1 0-2.12l4-4A1.5 1.5 0 0 1 5.5.037z" fill="#fff" class="layer"/></svg></i>',
//   nextArrow: '<i class="icon icon-chevron-right"><svg aria-hidden="true" focusable="false" role="presentation"  viewBox="0 0 7 11"><path d="M1.5 11A1.5 1.5 0 0 1 .44 8.44L3.38 5.5.44 2.56A1.5 1.5 0 0 1 2.56.44l4 4a1.5 1.5 0 0 1 0 2.12l-4 4A1.5 1.5 0 0 1 1.5 11z" fill="#fff"/></svg> </i>',
//   slidesToShow: 1,
//   slidesToScroll: 1,
// });

$(document).ready(function() {
    const button = $('.cstm-btn'); // Select the button with class 'cstm-btn'
    const cookieName = 'scrollToButton';
    const scrollTimeoutDuration = 1500; // Timeout duration for scroll completion (1.5 seconds)
    const headerHeight = 60; // Adjust this value to the height of any fixed header (if applicable)
    let isScrolling = false; // Flag to prevent multiple scrolls
    let scrollTimeout;

    // Function to clear the cookie
    function clearCookie() {
        document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/'; // Clear the cookie
    }

    // Function to scroll to the button and center it in the viewport
    function scrollToButton(retries = 3) {
        return new Promise((resolve, reject) => {
            if (button.length && !isScrolling) {
                isScrolling = true; // Set flag to prevent multiple scrolls

                // console.log("Scrolling to button...");

                // Set a timeout to ensure we don't scroll forever
                scrollTimeout = setTimeout(() => {
                    reject("Scroll timeout reached."); // Reject if timeout exceeds
                    isScrolling = false; // Reset the scrolling flag if timeout occurs
                }, scrollTimeoutDuration);

                // Calculate the position to center the button on the screen
                const targetPosition = button.offset().top - (window.innerHeight / 2) + (button.outerHeight() / 2);

                // Perform the scroll
                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth' // Smooth scroll
                });

                // Use a simple check to see if the scroll is completed
                const checkScrollCompletion = function onScroll() {
                    // When the scroll event triggers, check if the scroll position has reached the target
                    if (Math.abs(window.scrollY - targetPosition) < 2) {
                        clearTimeout(scrollTimeout); // Clear timeout when scroll is complete
                        $(window).off('scroll', checkScrollCompletion); // Remove the scroll listener
                        clearCookie(); // Clear the cookie after scroll is complete
                        isScrolling = false; // Reset the scrolling flag
                        resolve(); // Resolve the promise
                    }
                };

                $(window).on('scroll', checkScrollCompletion);

                // Retry if scroll is not completed successfully
                setTimeout(() => {
                    if (isScrolling) {
                        if (retries > 0) {
                            console.log(`Retrying scroll to button... (Remaining retries: ${retries})`);
                            scrollToButton(retries - 1).then(resolve).catch(reject); // Retry scroll
                        } else {
                            reject("Failed to scroll to button after multiple attempts.");
                        }
                    }
                }, 1000); // Retry after 1 second
            } else {
                reject("Button not found or already scrolling.");
            }
        });
    }

    // Ensure DOM is ready and the scroll happens after the page is fully loaded
    $(window).on('load', function() {
        // Check if cookie exists and scroll to the button if necessary
        if (document.cookie.includes(cookieName)) {
            scrollToButton().catch((err) => {
                console.error(err);
            });
        }
    });

    // Set cookie when the button is clicked
    button.on('click', function() {
        document.cookie = cookieName + '=true; path=/; max-age=3600'; // Set cookie for 1 hour
    });

    // Listen for the popstate event (back navigation via browser)
    $(window).on('popstate', function() {
        if (document.cookie.includes(cookieName) && !isScrolling) {
            // console.log("Back navigation detected. Scrolling to button...");
            scrollToButton().catch((err) => {
                console.error(err);
            }); // Scroll to button on back navigation
        }
    });
});

// top banner

$(document).ready(function() {
    const button = $('.scrl_tp'); // Select the button with class 'scrl_tp'
    const cookieName = 'scrollToTop'; // Cookie name for top scroll action
    const scrollTimeoutDuration = 1500; // Timeout duration for scroll completion (1.5 seconds)
    let isScrolling = false; // Flag to prevent multiple scrolls
    let scrollTimeout;

    // Function to clear the cookie
    function clearCookie() {
        document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/'; // Clear the cookie
    }

    // Function to scroll to the top of the page
    function scrollToTop(retries = 3) {
        return new Promise((resolve, reject) => {
            if (!isScrolling) {
                isScrolling = true; // Set flag to prevent multiple scrolls

                // console.log("Scrolling to top...");

                // Set a timeout to ensure we don't scroll forever
                scrollTimeout = setTimeout(() => {
                    reject("Scroll timeout reached."); // Reject if timeout exceeds
                    isScrolling = false; // Reset the scrolling flag if timeout occurs
                }, scrollTimeoutDuration);

                // Perform the scroll to the top of the page
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth' // Smooth scroll
                });

                // Check if the scroll is completed
                const checkScrollCompletion = function onScroll() {
                    // When the scroll event triggers, check if the scroll position has reached the top
                    if (window.scrollY === 0) {
                        clearTimeout(scrollTimeout); // Clear timeout when scroll is complete
                        $(window).off('scroll', checkScrollCompletion); // Remove the scroll listener
                        clearCookie(); // Clear the cookie after scroll is complete
                        isScrolling = false; // Reset the scrolling flag
                        resolve(); // Resolve the promise
                    }
                };

                $(window).on('scroll', checkScrollCompletion);

                // Retry if scroll is not completed successfully
                setTimeout(() => {
                    if (isScrolling) {
                        if (retries > 0) {
                            console.log(`Retrying scroll to top... (Remaining retries: ${retries})`);
                            scrollToTop(retries - 1).then(resolve).catch(reject); // Retry scroll
                        } else {
                            reject("Failed to scroll to top after multiple attempts.");
                        }
                    }
                }, 1000); // Retry after 1 second
            } else {
                reject("Already scrolling or button not found.");
            }
        });
    }

    // Ensure DOM is ready and the scroll happens after the page is fully loaded
    $(window).on('load', function() {
        // Check if cookie exists and scroll to the top if necessary
        if (document.cookie.includes(cookieName)) {
            scrollToTop().catch((err) => {
                console.error(err);
            });
        }
    });

    // Set cookie when the button is clicked
    button.on('click', function() {
        document.cookie = cookieName + '=true; path=/; max-age=3600'; // Set cookie for 1 hour
        scrollToTop().catch((err) => {
            console.error(err);
        });
    });

    // Listen for the popstate event (back navigation via browser)
    $(window).on('popstate', function() {
        if (document.cookie.includes(cookieName) && !isScrolling) {
            console.log("Back navigation detected. Scrolling to top...");
            scrollToTop().catch((err) => {
                console.error(err);
            }); // Scroll to top on back navigation
        }
    });
});




// document.addEventListener("DOMContentLoaded", () => {
//   // Select all divs that have h2 + leaf-icon classes
//   const containers = document.querySelectorAll('.text-block.h2.leaf-icon');

//   containers.forEach(container => {
//     const h2 = container.querySelector('h2'); // H2 inside this container
//     if (h2 && !h2.querySelector('.leaf')) { // avoid duplicates
//       const span = document.createElement('span');
//       span.classList.add('leaf');
//       h2.appendChild(span); // add span at the end of H2
//     }
//   });
// });


// document.addEventListener("DOMContentLoaded", () => {
//   // Select all divs with class including h2
//   const containers = document.querySelectorAll('.text-block.h2');

//   containers.forEach(container => {
//     const h2 = container.querySelector('h2'); // h2 inside this container
//     if (h2 && !h2.querySelector('.leaf')) { // avoid duplicate
//       const span = document.createElement('span');
//       span.classList.add('leaf');
//       h2.appendChild(span); // add span at the end of h2
//     }
//   });
// });

